// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_5k-0";
export var eligibilityCardNotEligible = "_5k-1";